import { Campaign } from 'models/Campaign.model';
import { Image, Container } from './CampaignComponent.styles';

interface CampaignComponentProps {
  data: Campaign;
  onClickCampaign: (campaign: Campaign) => void;
}

export const CampaignComponent = ({
  data,
  onClickCampaign,
}: CampaignComponentProps) => {
  const { imageUrl, name, redirectUrl } = data;

  const onClickCampaignHandler = () => {
    if (redirectUrl) {
      onClickCampaign(data);
    }
  };

  const getHtmlDisplay = () => {
    if (redirectUrl) {
      return 'button';
    }
    return 'div';
  };

  return (
    <Container
      data-testid="campaign-container"
      onClick={onClickCampaignHandler}
      as={getHtmlDisplay()}
      hasUrl={!!redirectUrl}
    >
      <Image data-testid="campaign-image" src={imageUrl} alt={name} />
    </Container>
  );
};
